import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CollapseBlock, Spinner } from '../../../../common';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import { useToastMessages } from '../../../../../hooks/useToastMessages';
import {
  useArchiveYellowBookMutation,
  useDeleteYellowBookMutation,
  useGetYellowBooksQuery,
} from '../../../../../redux/services/yellow_books';
import YellowBooksTable from './YellowBooksTable.jsx';
import FormRadioGroup from '../../../../antd/form/FormRadioGroup/FormRadioGroup';

const YellowBooksPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const options = [
    { label: t('Zoznam aktívnych žltých knižiek'), value: false },
    { label: t('Zoznam archivovaných žltých knižiek'), value: true },
  ];

  const [isArchived, setIsArchived] = useState(false);
  const { data: yellowBooks, isLoading, refetch } = useGetYellowBooksQuery();

  useEffect(() => {
    document.title = t('Žlté knižky') + ' - FRI CMS';
  }, []); // Runs on mount

  const [deleteYellowBook, { isSuccess: isSuccessDelete }] =
    useDeleteYellowBookMutation();

  const [archiveYellowBook, { isSuccess: isSuccessArchived }] =
    useArchiveYellowBookMutation();

  const { deleteSuccess: showDeleteSuccess, saveSuccess: showSaveSuccess } =
    useToastMessages();

  useEffect(() => {
    if (isSuccessDelete) {
      showDeleteSuccess();
      refetch();
    }
  }, [isSuccessDelete]);

  useEffect(() => {
    if (isSuccessArchived) {
      showSaveSuccess();
      refetch();
    }
  }, [isSuccessArchived]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Žlté knižky')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        createText={t('Pridať žltú knižku')}
        createUrl={routes.cmsYellowBooksCreate}
        permissionsBasic="yellow-books"
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock title={t('Filter žltých knižiek')}>
          <FormRadioGroup
            options={options}
            value={isArchived}
            optionType="button"
            onChange={setIsArchived}
          />
        </CollapseBlock>
        <CollapseBlock
          title={
            isArchived
              ? t('Zoznam archivovaných žltých knižiek')
              : t('Zoznam aktívnych žltých knižiek')
          }
        >
          <YellowBooksTable
            yellowBooks={yellowBooks?.filter((item) =>
              isArchived ? item.archived_at != null : item.archived_at == null,
            )}
            isArchived={isArchived}
            onDelete={(record) => deleteYellowBook(record.id)}
            onDetailClick={(record) =>
              navigate(`${routes.cmsYellowBooksEdit}/${record.id}`)
            }
            onSectionClick={(record) =>
              navigate(routes.cmsYellowBooksSections(record.id))
            }
            onArchiveClick={(record) =>
              archiveYellowBook({
                id: record.id,
                title: record.title,
                archive: true,
              })
            }
            onActivateClick={(record) =>
              archiveYellowBook({
                id: record.id,
                title: record.title,
                archive: false,
              })
            }
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default YellowBooksPage;
